module.exports = "<p>\r\n  Page Not Found\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/page-not-found/page-not-found.component.html
// module id = ./src/app/core/page-not-found/page-not-found.component.html
// module chunks = main